import { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchFeatureFlags } from "@/store/featureFlagStoreACTIONS";

// Feature flags live in a module-singleton Zustand store, which means each browser
// window has its OWN copy. The trade pop-out (react-new-window with a `url`) boots the
// app in a separate window/JS context, so its store starts empty. This loader sits in
// _app.tsx above the Popout/main branch, so EVERY window — main app and pop-out alike —
// fetches its own flags. (See LQC-1724.)
export function FeatureFlagLoader() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || hasFetched.current) return;
    hasFetched.current = true;
    fetchFeatureFlags(getAccessTokenSilently);
  }, [isAuthenticated, getAccessTokenSilently]);

  return null;
}
